// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jn-0";
export var buttonContainer = "_jn-3";
export var cancelButton = "_jn-4";
export var headerSection = "_jn-6";
export var headerTitle = "_jn-9";
export var messageSideLeft = "_jn-1";
export var messageSideRight = "_jn-2";
export var orderNumberContainer = "_jn-7";
export var orderNumberLabel = "_jn-8";
export var submitButton = "_jn-5";